import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import ContentTemplate from "./content-template"
import { convertTimeToAziaZone } from "../../functions/convert-time-to-azia-timezone"

// 管理画面側で何もコンテンツが設定されていない場合に、こちらが呼び出される
export default function NoContentAfterVideo() {
  const dataWhenNoContent = useStaticQuery(
    graphql`
    query NoContentQuery {
      note: allMicrocmsNotes(
        filter: {large_category: {ne: "自由研究"}}
        limit: 1
        sort: {fields: publishedAt, order: DESC}
      ) {
        edges {
          node {
            id
            publishedAt
            notesId
            thumbnail {
              url
            }
            title
            tags {
              name
              id
            }
          }
        }
      }
    }`
  )

  let publishDate = ''
  let title = ''
  let imageUrl = ''
  let tagName = ''
  let link = ''

  const data = dataWhenNoContent.note.edges[0].node
  publishDate = convertTimeToAziaZone(data.publishedAt,'YYYY.MM.DD')
  title = data.title
  imageUrl = data.thumbnail ? data.thumbnail.url : ''
  tagName = data.tags.length ? data.tags[0].name : ''
  link = `/note/${data.notesId}`

  return (
    <ContentTemplate
      publishDate={publishDate}
      title={title}
      imageUrl={imageUrl}
      tagName={tagName}
      link={link}
    />
  )
}
